module.exports = __webpack_public_path__ + "static/media/grids_logo.6846cd69.svg";